import { ButtonGroup, GroupButton } from 'ui/buttonGroup';
import { isDefined } from 'utils/tsHelpers';
import { sentenceCase } from 'utils/stringHelpers';
import { Combinator } from '../../../domain';
import {
  useAddCondition,
  useClauseCombinatorController,
  useHasMultipleConditions,
} from '../../../hooks/form';

export const CombinatorSelect = () => {
  const hasMultipleConditions = useHasMultipleConditions();
  const addCondition = useAddCondition();
  const {
    field: { onChange, value: combinator },
  } = useClauseCombinatorController();
  const isSelectNull = isDefined(combinator) && hasMultipleConditions;

  const setCombinator = (value: Combinator) => onChange({ target: { value } });

  if (isSelectNull) return null;

  return (
    <ButtonGroup id="combinator-button-group" trackSelected>
      <GroupButton
        onSelect={() => {
          setCombinator(Combinator.AND);
          addCondition();
        }}
      >
        {sentenceCase(Combinator.AND)}
      </GroupButton>
      <GroupButton
        onSelect={() => {
          setCombinator(Combinator.OR);
          addCondition();
        }}
      >
        {sentenceCase(Combinator.OR)}
      </GroupButton>
    </ButtonGroup>
  );
};
